import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { variableFontRegular } from 'styles/theme';

export interface IChoice {
  'data-qa'?: string;
  checked: boolean;
  className?: string;
  invertChecked?: boolean;
  label: string | ReactNode;
  name?: string;
  onChange: (e) => void;
  type: 'checkbox' | 'radio';
  value: number | string;
  darkTheme?: boolean;
}

export const Choice = ({
  'data-qa': dataQa,
  checked,
  className,
  invertChecked,
  label,
  name,
  onChange,
  type,
  value,
  darkTheme,
}: IChoice) => (
  <Choice.Label
    $checked={checked}
    $darkTheme={darkTheme}
    $invertChecked={invertChecked}
    className={className}
    data-qa={dataQa}
  >
    <Choice.Input checked={checked} onChange={onChange} name={name} type={type} value={value} />
    {label}
  </Choice.Label>
);

Choice.Label = styled.label<{
  $checked: IChoice['checked'];
  $darkTheme: IChoice['darkTheme'];
  $invertChecked: IChoice['invertChecked'];
}>`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-height: 24px;
  min-width: 24px;
  padding: 4px;
  text-transform: capitalize;
  white-space: nowrap;
  ${variableFontRegular({ height: '12px', size: '9.5px' })}
  ${({ $checked, $darkTheme }) =>
    $checked
      ? css`
          border: ${({ theme }) => ($darkTheme ? theme.borders.white : theme.navigation.border)};
        `
      : css`
          border: ${({ theme }) =>
            $darkTheme ? theme.borders.black : theme.navigation.inverseBorder};
        `}
  ${({ $checked, $invertChecked }) =>
    $checked &&
    $invertChecked &&
    css`
      color: ${({ theme }) => theme.colors.white};
      background: ${({ theme }) => theme.colors.black};
    `}
`;

Choice.Input = styled.input`
  height: 0;
  position: absolute;
  width: 0;
  visibility: hidden;
`;
